import { CollapsingParameters } from '../../game_config/game_config';

export class CollapsingSpinConfig {
  public collapsingParameters: CollapsingParameters | null = null;

  constructor(configDto?: { collapsingParameters: CollapsingParameters }) {
    if (configDto) {
      if (Object.prototype.hasOwnProperty.call(configDto, 'collapsingParameters')) {
        this.collapsingParameters = new CollapsingParameters(configDto['collapsingParameters']);
      }
    }
  }
}
